var map = {
	"./devices.harvesterhci.io.migconfiguration": 96885,
	"./devices.harvesterhci.io.migconfiguration.vue": 96885,
	"./devices.harvesterhci.io.pcidevice": 95426,
	"./devices.harvesterhci.io.pcidevice.vue": 95426,
	"./devices.harvesterhci.io.sriovgpudevice": 94879,
	"./devices.harvesterhci.io.sriovgpudevice.vue": 94879,
	"./devices.harvesterhci.io.sriovnetworkdevice": 32436,
	"./devices.harvesterhci.io.sriovnetworkdevice.vue": 32436,
	"./devices.harvesterhci.io.usbdevice": 11061,
	"./devices.harvesterhci.io.usbdevice.vue": 11061,
	"./devices.harvesterhci.io.vgpudevice": 79925,
	"./devices.harvesterhci.io.vgpudevice.vue": 79925,
	"./harvesterhci.io.addon": 73987,
	"./harvesterhci.io.addon.vue": 73987,
	"./harvesterhci.io.cloudtemplate": 10263,
	"./harvesterhci.io.cloudtemplate.vue": 10263,
	"./harvesterhci.io.dashboard": 88854,
	"./harvesterhci.io.dashboard.vue": 88854,
	"./harvesterhci.io.host": 31319,
	"./harvesterhci.io.host.vue": 31319,
	"./harvesterhci.io.logging.clusterflow": 17945,
	"./harvesterhci.io.logging.clusterflow.vue": 17945,
	"./harvesterhci.io.logging.clusteroutput": 76395,
	"./harvesterhci.io.logging.clusteroutput.vue": 76395,
	"./harvesterhci.io.logging.flow": 230,
	"./harvesterhci.io.logging.flow.vue": 230,
	"./harvesterhci.io.logging.output": 92062,
	"./harvesterhci.io.logging.output.vue": 92062,
	"./harvesterhci.io.monitoring.alertmanagerconfig": 84235,
	"./harvesterhci.io.monitoring.alertmanagerconfig.vue": 84235,
	"./harvesterhci.io.networkattachmentdefinition": 98975,
	"./harvesterhci.io.networkattachmentdefinition.vue": 98975,
	"./harvesterhci.io.schedulevmbackup": 18167,
	"./harvesterhci.io.schedulevmbackup.vue": 18167,
	"./harvesterhci.io.secret": 28470,
	"./harvesterhci.io.secret.vue": 28470,
	"./harvesterhci.io.setting": 6210,
	"./harvesterhci.io.setting.vue": 6210,
	"./harvesterhci.io.storage": 67818,
	"./harvesterhci.io.storage.vue": 67818,
	"./harvesterhci.io.virtualmachinebackup": 99050,
	"./harvesterhci.io.virtualmachinebackup.vue": 99050,
	"./harvesterhci.io.virtualmachineimage": 74229,
	"./harvesterhci.io.virtualmachineimage.vue": 74229,
	"./harvesterhci.io.virtualmachinetemplateversion": 43717,
	"./harvesterhci.io.virtualmachinetemplateversion.vue": 43717,
	"./harvesterhci.io.vmsnapshot": 87897,
	"./harvesterhci.io.vmsnapshot.vue": 87897,
	"./harvesterhci.io.volume": 73683,
	"./harvesterhci.io.volume.vue": 73683,
	"./harvesterhci.io.volumesnapshot": 9579,
	"./harvesterhci.io.volumesnapshot.vue": 9579,
	"./kubeovn.io.vpc": 51268,
	"./kubeovn.io.vpc.vue": 51268,
	"./kubevirt.io.virtualmachine": 4940,
	"./kubevirt.io.virtualmachine.vue": 4940,
	"./migration.harvesterhci.io.openstacksource": 49788,
	"./migration.harvesterhci.io.openstacksource.vue": 49788,
	"./migration.harvesterhci.io.ovasource": 80035,
	"./migration.harvesterhci.io.ovasource.vue": 80035,
	"./migration.harvesterhci.io.virtualmachineimport": 88596,
	"./migration.harvesterhci.io.virtualmachineimport.vue": 88596,
	"./migration.harvesterhci.io.vmwaresource": 93103,
	"./migration.harvesterhci.io.vmwaresource.vue": 93103,
	"./network.harvesterhci.io.clusternetwork": 66011,
	"./network.harvesterhci.io.clusternetwork.vue": 66011,
	"./network.harvesterhci.io.hostnetworkconfig": 3712,
	"./network.harvesterhci.io.hostnetworkconfig.vue": 3712
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	var id = map[req];
	return __webpack_require__(id);
});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 78706;
module.exports = webpackAsyncContext;